module.exports = __webpack_public_path__ + "img/celeri.d75411ac.svg";